import { InputNumber } from "antd";
import { VyneInputAddonWrapper } from "./VyneInputAddonWrapper";
import type { InputNumberProps } from "antd";
import type { ReactNode } from "react";
import type { RequireAtLeastOne } from "utils/types";
import type { SpaceCompactProps } from "antd/es/space/Compact";

type AddonRenderer = ReactNode | ((className?: string) => ReactNode);

type VyneInputNumberWithAddonProps = Omit<InputNumberProps<number>, "addonBefore" | "addonAfter"> & {
    readonly addonBefore?: AddonRenderer;
    readonly addonAfter?: AddonRenderer;
    readonly wrapperProps?: Omit<SpaceCompactProps, "children">;
};

type VyneInputNumberWithAddonRequiredProps = RequireAtLeastOne<
    VyneInputNumberWithAddonProps,
    "addonBefore" | "addonAfter"
>;

export const VyneInputNumberWithAddon = ({
    addonBefore,
    addonAfter,
    wrapperProps,
    className,
    ...inputProps
}: VyneInputNumberWithAddonRequiredProps) => {
    const classNames = ["vyne-input-addon-input", className].filter(Boolean).join(" ");

    return (
        <VyneInputAddonWrapper addonBefore={addonBefore} addonAfter={addonAfter} wrapperProps={wrapperProps}>
            <InputNumber<number> className={classNames} {...inputProps} />
        </VyneInputAddonWrapper>
    );
};

VyneInputNumberWithAddon.displayName = "VyneInputNumberWithAddon";
